import React from 'react'
import effects from 'app/effects/effects'
import ApiPicturesPanel from './ApiPicturesPanel'
import { panelParseResponse } from 'libs/PagingParser'
import { FormattedMessage } from 'react-intl'
import { itemMapper } from './ItemMapper'
import EmptyContent from 'app/components/empty/EmptyContent'
import { Routes } from 'app/services/routeService/routeService'
import { withRouter } from 'react-router'

const SUMMARY_COUNT = 8
const apiFetcher = () =>
  effects.apis
    .teamMembers({ page: 1, limit: SUMMARY_COUNT })
    .then(panelParseResponse(itemMapper))

export default withRouter(({ history, teamMembersPageSection = false }) => {
  return (
    <ApiPicturesPanel
      ApiPanelProp={{
        title: <FormattedMessage id="navigation.settings.teamMembers.label" />,
        link: Routes.teamMembers(),
        apiFetcher: apiFetcher,
        onItemClick: (teamMember) => {
          history.push(Routes.editTeamMember(teamMember.id))
        },
        withCrmField: false,
        teamMembersPageSection: teamMembersPageSection,
      }}
      emptyContent={
        <EmptyContent
          linkProp={{ to: Routes.teamMembers() }}
          linkLabel={<FormattedMessage id="empty.teamAdmins.link" />}
          descriptionLabel={<FormattedMessage id="empty.teamAdmins.desc" />}
        />
      }
    />
  )
})
